import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CoverageModel } from './coverage-modal-base.model';
import { ProductService } from '../../core/http/apiProduct/product.service';
import { IPantalla } from '../../core/interfaces/response/IGetPantallasResponse';
import { SpinnerService } from '../../core/services/spinner/spinner.service';
import { AnalyticsService } from '../../core/services/adobe-analytics/analytics.service';
import { environment } from '../../../environments/environment';
import { Utils } from '../utils/utils';

@Component({
  selector: 'app-coverage-modal-base',
  templateUrl: './coverage-modal-base.component.html',
  styleUrls: ['./coverage-modal-base.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CoverageModalBaseComponent {
  
  public title: String;
  public subtitle: String;
  public description: String;
  public coverageList: IPantalla[]= [];
  public coverageDetails: IPantalla[] = [];
  public readonly coveragePantallaInfo = {
    DETAILS: 1,
    LIST: 2,
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: CoverageModel,
    private productService: ProductService,
    private spinnerService: SpinnerService,
    private analyticsService: AnalyticsService,
  ) { }

  ngOnInit(): void {
    this.analyticsService.resetDataLayer();
    const today = new Date();
    const dateString = today.toISOString();
    this.processData(this.data);

    this.set_initial_analytics_config('click-boton:main-body:ver coberturas', 
      'imPageview', 
      'app_cotizador:area_publica:coberturas')
    this.analyticsService.startEventWithCallback('imPageview', () => {});
  }

  private processData(data: CoverageModel) {
    this.spinnerService.show();
    if (data.coverageList?.alias && data.coverageList?.aliasProduct) {
      this.getCoverageList(
        this.data.coverageList.alias,
        this.data.coverageList.aliasProduct
      );
      this.getCoverageDetails(
        this.data.coverageDet.alias,
        this.data.coverageDet.aliasProduct
      );
    } else {
      this.getPantallasFiltrado(data.idPantalla, data.idProducto);
    }
  }

  getPantallasFiltrado(idPantalla: number, idProducto: number) {
    this.productService
      .getPantallasFiltrando(idPantalla, idProducto)
      .subscribe(
        (data: any) => {
          this.coverageList = data['2'];
          this.title = data['1'][0].title;
          this.description = data['1'][0].descripcion;
          this.spinnerService.hide();

          this.coverageDetails = data[this.coveragePantallaInfo.DETAILS];
        },
        (error: any) => {
          console.log(error);
          this.spinnerService.hide();
        }
      );
  }

  getCoverageList(alias: any, aliasProduct: any) {
    this.productService.getPantallas(alias, aliasProduct).subscribe(
      (res: any) => {
        this.title = res['1'][0].descripcion;
        this.coverageList = res['2'];
        this.spinnerService.hide();
      },
      (err: any) => {
        console.log(err);
        this.spinnerService.hide();
      }
    );
  }

  getCoverageDetails(alias: any, aliasProduct: any) {
    this.productService.getPantallas(alias, aliasProduct).subscribe(
      (res: any) => {
        this.coverageDetails = res['1'];
        this.spinnerService.hide();
      },
      (err: any) => {
        console.log(err);
        this.spinnerService.hide();
      }
    );
  }

  handleDropdownLinkClick(event: { type: 'email' | 'info', value: string }) {
    if (event.type === 'email') {
      this.openCoverageEmail();
    } else if (event.type === 'info') {
      this.openCoverageInfo();
    }
  }

  openCoverageDetails(coverageType:string){
    if(coverageType.includes('dudas')){
      this.set_initial_analytics_config('click-boton:main-body:mas dudas', 
        'clickElement', 
        'app_cotizador:area_publica:coberturas')
      this.analyticsService.startEventWithCallback('clickElement', () => {});
    }else if (coverageType.includes('seguro')){
      this.set_initial_analytics_config('click-boton:main-body:uso seguro', 
        'clickElement', 
        'app_cotizador:area_publica:coberturas')
      this.analyticsService.startEventWithCallback('clickElement', () => {});
    }
  }

  openCoverageEmail(){
    this.set_initial_analytics_config('click-boton:main-body:uso seguro', 
      'clickElement', 
      'app_cotizador:area_publica:email')
    this.analyticsService.startEventWithCallback('clickElement', () => {});
  }

  openCoverageInfo(){
    this.set_initial_analytics_config('click-boton:main-body:mas dudas', 
      'clickElement', 
      'app_cotizador:area_publica: document informacion')
    this.analyticsService.startEventWithCallback('clickElement', () => {});
  }


  /**
    * Set all the analytics' related info for the current component
  */
  private set_initial_analytics_config(categoryActionLabel: string, eventName: string, pageName: string ): void {

    this.analyticsService.resetDataLayer();    
    const sessionData = this.getAnalyticsDataFromSession();
    /* ===================== */
    /* PAGE DATA */
    /* ===================== */
    this.analyticsService.setPhysicalUrl(environment.baseUrl + sessionData.aliasProducto);
    this.analyticsService.setPageName(pageName);
    this.analyticsService.setPageContentType('cotizador');
    this.analyticsService.setPageDigitalChannel('app_cotizador');
    this.analyticsService.setPageSection('area_publica');
    this.analyticsService.setPageLanguage('es');
    this.analyticsService.setNivel1('sales');
    this.analyticsService.setNivel2('addAccessoriesSelection');

    /* ===================== */
    /* PROCESS DATA */
    /* ===================== */
    this.analyticsService.setProcessStep('1');
    this.analyticsService.setProcessType('sales');
    this.analyticsService.setProcessName('quotation_addAccessoriesSelection');
    this.analyticsService.setProcessStatus('iniciado');

    /* ===================== */
    /* USER DATA */
    /* ===================== */
    this.analyticsService.setUserStatus('no_logado');
    this.analyticsService.setUserLang('es');

    const userBirth = sessionStorage.getItem('userBirth') ?? '';
    this.analyticsService.setUserBirth(userBirth);
    this.analyticsService.setUserResidence('VERDADERO');

    /* ===================== */
    /* PRODUCT DATA (DINÁMICO) */
    /* ===================== */

    this.analyticsService.setCategoryActionLabel(categoryActionLabel)
    this.analyticsService.setProductName(Utils.sanitizeString(sessionData.productName));
    this.analyticsService.setProductType(Utils.sanitizeString(sessionData.productType));
    this.analyticsService.setProductArea(sessionData.productArea);
    this.analyticsService.setProductDate(this.getProductDate());

    const productCostStart = sessionData.productCostStart;
    const productCostUpgrades = sessionData.productCostUpgrades;
    this.analyticsService.setProductCostStart(productCostStart);
    this.analyticsService.setProductCostUpgrades(productCostUpgrades);
  }

  private getAnalyticsDataFromSession(): any {
    const stored = sessionStorage.getItem('analyticsData');
    if (!stored) return null;
    return JSON.parse(stored);
  }

  private getProductDate(): string {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    return `${year}-${month}`;
  }
}
